import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        redirectTo: 'creacion-clave',
        pathMatch: 'full'
      },
      {
        path: 'creacion-clave',
        loadChildren: './features/creacion-clave/creacion-clave.module#CreacionClaveModule'
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'creacion-clave',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})

export class AppRoutingModule { }




// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts